<div class="w-full p-5 card">

    <form [formGroup]="courseForm" (ngSubmit)="onSubmit()" >

        <div class="grid grid-cols-1 gap-5">

            <div class="col-span-1">
                <label class="form-control w-full ">
                    <div class="label">
                        <span class="label-text font-semibold text-xs req">Course Name</span>
                    </div>
                    <input [ngClass]="{'error': courseForm.get('course_name')!.touched && (courseForm.get('course_name')!.hasError('required') || courseForm.get('course_name')!.hasError('maxlength'))}"
                     type="text" class="input input-bordered w-full " formControlName="course_name"/>
                    @if ( courseForm.get('course_name')!.touched && courseForm.get('course_name')!.hasError('required')) {
                        <p class="text-xs text-red-500 mt-1">Course name is required</p>
                    }
                    @if ( courseForm.get('course_name')!.touched && courseForm.get('course_name')!.hasError('courseNameAllowedChars')) {
                        <p class="text-xs text-red-500 mt-1">Please enter a valid course name.</p>
                    }
                    @if ( courseForm.get('course_name')!.touched && courseForm.get('course_name')!.hasError('courseNameNoAllSpaces')) {
                        <p class="text-xs text-red-500 mt-1">Please enter a valid course name.</p>
                    }
                    @if ( courseForm.get('course_name')!.touched && courseForm.get('course_name')!.hasError('courseNameMinLength')) {
                        <p class="text-xs text-red-500 mt-1">Course name must be at least 2 characters.</p>
                    }
                    @if ( courseForm.get('course_name')!.touched && courseForm.get('course_name')!.hasError('courseNameTrim')) {
                        <p class="text-xs text-red-500 mt-1">Course name must not have leading or trailing spaces.</p>
                    }
                    @if ( courseForm.get('course_name')!.touched && courseForm.get('course_name')!.hasError('maxlength')) {
                        <p class="text-xs text-red-500 mt-1">Course name must be between 2 and 100 characters.</p>
                    }

                </label>
            </div>

            @if ((courseType$ | async)?.type === 'video') {
            <div class="col-span-1">
                <label class="form-control w-full ">
                    <div class="label">
                        <span class="label-text font-semibold text-xs req">Video Playback time (In Seconds)</span>
                    </div>
                    <input min="1" [ngClass]="{'error': (courseForm.get('video_time')!.touched || courseForm.get('video_time')!.dirty) && courseForm.get('video_time')!.invalid}"
                     type="text" inputmode="numeric" class="input input-bordered w-full "
                     formControlName="video_time" (input)="onPlaybackInput('video_time', $event)" />
                    @if ( courseForm.get('video_time')!.touched && courseForm.get('video_time')!.hasError('required')) {
                        <p class="text-xs text-red-500 mt-1">Video playback time is required.</p>
                    }
                    @if ( courseForm.get('video_time')!.touched && courseForm.get('video_time')!.hasError('pattern')) {
                        <p class="text-xs text-red-500 mt-1">Playback time must be digits only (no alphabets or special characters).</p>
                    }
                    @if ( courseForm.get('video_time')!.touched && courseForm.get('video_time')!.hasError('min')) {
                        <p class="text-xs text-red-500 mt-1">Playback time must be greater than 0.</p>
                    }
                    @if ( courseForm.get('video_time')!.touched && courseForm.get('video_time')!.hasError('max')) {
                        <p class="text-xs text-red-500 mt-1">Please enter a valid video playback time.</p>
                    }
                </label>
            </div>

            <div class="col-span-1">
                <label class="form-control w-full ">
                    <div class="label">
                        <span class="label-text font-semibold text-xs req">Video Playback Limit</span>
                    </div>
                    <input [ngClass]="{'error': (courseForm.get('video_limit')!.touched || courseForm.get('video_limit')!.dirty) && courseForm.get('video_limit')!.invalid}"
                    min="1" max="100" type="text" inputmode="numeric" class="input input-bordered w-full "
                    formControlName="video_limit" (input)="onPlaybackInput('video_limit', $event)"/>
                    @if ( courseForm.get('video_limit')!.touched && courseForm.get('video_limit')!.hasError('required')) {
                        <p class="text-xs text-red-500 mt-1">Video playback limit is required.</p>
                    }
                    @if ( courseForm.get('video_limit')!.touched && courseForm.get('video_limit')!.hasError('pattern')) {
                        <p class="text-xs text-red-500 mt-1">Playback limit must be digits only (no alphabets or special characters).</p>
                    }
                    @if ( courseForm.get('video_limit')!.touched && courseForm.get('video_limit')!.hasError('min')) {
                        <p class="text-xs text-red-500 mt-1">Playback limit must be greater than 0.</p>
                    }
                    @if ( courseForm.get('video_limit')!.touched && courseForm.get('video_limit')!.hasError('max')) {
                        <p class="text-xs text-red-500 mt-1">Please enter a valid playback limit.</p>
                    }
                </label>
            </div>
        }

            <div class="col-span-1">
                <label class="form-control w-full ">
                    <div class="label">
                        <span class="label-text font-semibold text-xs req">Description</span>
                    </div>
                    <textarea [ngClass]="{'error': courseForm.get('description')!.touched && (courseForm.get('description')!.hasError('required') || courseForm.get('description')!.hasError('maxlength'))}"
                        placeholder="Write a short description about the course" rows="4"
                        required
                        name="description" id="description" class="textarea textarea-bordered h-24" formControlName="description"></textarea>
                    @if ( courseForm.get('description')!.touched && courseForm.get('description')!.hasError('required')) {
                        <p class="text-xs text-red-500 mt-1">Description is required.</p>
                    }

                    @if ( courseForm.get('description')!.touched && courseForm.get('description')!.hasError('descriptionMinLength')) {
                        <p class="text-xs text-red-500 mt-1">Description must be between 10 and 1000 characters.</p>
                    }

                    @if ( courseForm.get('description')!.touched && courseForm.get('description')!.hasError('maxlength')) {
                        <p class="text-xs text-red-500 mt-1">Description must be between 10 and 1000 characters.</p>
                    }
                       @if ( courseForm.get('description')!.touched && courseForm.get('description')!.hasError('descriptionTrim')) {
                        <p class="text-xs text-red-500 mt-1">Description must not have leading or trailing spaces.</p>
                    }
                    @if (
                        courseForm.get('description')!.touched &&
                        (courseForm.get('description')!.hasError('descriptionAllowedChars') || courseForm.get('description')!.hasError('descriptionTrim'))
                    ) {
                        <p class="text-xs text-red-500 mt-1">Please enter a valid description.</p>
                    }
                </label>
            </div>

            <div class="col-span-1">
                <div class="form-contro w-full ">
                    <div class="label">
                        <span class="label-text font-semibold text-xs req">Useful For</span>
                    </div>
                    <div class="flex flex-wrap gap-2 mb-2">
  @for (i of usefulHints; track $index) {
    <button
      type="button"
      (click)="removeUsefulHint($index)"
      [title]="i"
      class="btn btn-xs max-w-full sm:max-w-[220px] md:max-w-[260px] lg:max-w-[300px] flex items-center gap-1"
    >
      <span class="truncate flex-1 text-left">
        {{ i }}
      </span>

      <i class="ri-close-line shrink-0"></i>
    </button>
  }
</div>
                    <label [ngClass]="{'error': courseForm.get('usefull_for_hint')!.touched && (courseForm.get('usefull_for_hint')!.hasError('required') || courseForm.get('usefull_for_hint')!.hasError('maxHintLength') || courseForm.get('usefull_for_hint')!.hasError('maxTotalLength'))}"
                     class="input input-bordered flex items-center gap-2">
                        <input type="text" [class.input-has-hints]="usefulHints.length > 0" class="grow" placeholder="Search" name="usefulHints" [(ngModel)]="usefulHintInput" [ngModelOptions]="{standalone: true}"/>
                        <button type="button" (click)="addUsefulHint($event)" class="btn btn-circle btn-sm"><i class="ri-add-large-line"></i></button>
                    </label>
                    @if ( courseForm.get('usefull_for_hint')!.touched && courseForm.get('usefull_for_hint')!.hasError('required') ) {
                        <p class="text-xs text-red-500 mt-1">"Useful For" is required.</p>
                    }

                    @if ( courseForm.get('usefull_for_hint')!.touched && courseForm.get('usefull_for_hint')!.hasError('usefulForTrim') ) {
                        <p class="text-xs text-red-500 mt-1">"Useful For" must not have leading or trailing spaces.</p>
                    }

                    @if (
                      courseForm.get('usefull_for_hint')!.touched &&
                      (courseForm.get('usefull_for_hint')!.hasError('usefulForMinLength') || courseForm.get('usefull_for_hint')!.hasError('usefulForMaxLength'))
                    ) {
                        <p class="text-xs text-red-500 mt-1">"Useful For" must be between 2 and 200 characters.</p>
                    }

                    @if ( courseForm.get('usefull_for_hint')!.touched && courseForm.get('usefull_for_hint')!.hasError('usefulForAllowedChars') ) {
                        <p class="text-xs text-red-500 mt-1">"Useful For" contains invalid characters.</p>
                    }



                </div>
            </div>

            <div class="col-span-1">
                <div [ngClass]="{'error': courseForm.get('thumbnail')!.touched && (courseForm.get('thumbnail')!.hasError('required') || courseForm.get('thumbnail')!.hasError('thumbnailType') || courseForm.get('thumbnail')!.hasError('thumbnailSize') || courseForm.get('thumbnail')!.hasError('thumbnailCorrupted'))}" class="aspect-[16/9] w-full border-2 border-zinc-300 border-dashed rounded-md flex justify-center items-center relative group hover:border-zinc-500 overflow-hidden">

                    @if (thumbnailUrl) {
                        <div >
                            <img class="w-full h-full object-cover" src="{{thumbnailUrl}}" alt="">
                            <div class="flex items-center justify-center gap-2 text-white bg-black/50 backdrop-blur-sm absolute top-0 left-0 w-full h-full opacity-0 transition duration-300 group-hover:opacity-100">
                                <i class="ri-image-edit-fill text-3xl "></i>
                                <p class="text-sm  border-l border-white pl-2 font-medium">Change Thumbnail</p>
                                @if ((courseType$ | async)?.type === 'flashcard') {
                                    <p class="text-sm  border-l border-white pl-2 font-medium">Thumbnail Should be ( 500 x 500 ) under 2MB</p>
                                } @else {
                                    <p class="text-sm  border-l border-white pl-2 font-medium">Thumbnail Should be ( 1280 x 720 ) under 2MB</p>
                                }
                            </div>
                        </div>
                    }@else {
                        <div class="flex items-center gap-2 text-zinc-400">
                            <i class="ri-image-fill text-3xl group-hover:text-zinc-500"></i>
                            @if ((courseType$ | async)?.type === 'flashcard') {
                                <p class="text-sm  border-l border-zinc-300 pl-2 font-medium req">Upload Thumbnail ( 500 x 500 ) under 2MB</p>
                            } @else {
                                <p class="text-sm  border-l border-zinc-300 pl-2 font-medium req">Upload Thumbnail ( 1280 x 720 ) under 2MB</p>
                            }
                        </div>
                    }

                    <input type="file" (change)="onFileSelected($event)" class="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer" accept="image/*" name="" id="">
                </div>
                @if ( courseForm.get('thumbnail')!.touched && courseForm.get('thumbnail')!.hasError('required')) {
                    <p class="text-xs text-red-500 mt-1">Thumbnail is required</p>
                }
                @if ( courseForm.get('thumbnail')!.touched && courseForm.get('thumbnail')!.hasError('thumbnailType')) {
                    <p class="text-xs text-red-500 mt-1">Only JPG, JPEG, and PNG files are allowed.</p>
                }
                @if ( courseForm.get('thumbnail')!.touched && courseForm.get('thumbnail')!.hasError('thumbnailSize')) {
                    <p class="text-xs text-red-500 mt-1">File size must not exceed 2 MB.</p>
                }


            </div>

            <div class="flex justify-end gap-3 ">
                <!-- <button type="button" class="btn btn-sm capitalize btn-outline">save & preview</button> -->
                <button type="submit" class="btn btn-sm capitalize btn-primary" >
                    @if (isreqSending) {
                        <i class="ri-loader-2-line animate-spin"></i>
                    }@else {
                        <span>Save</span>
                    }
                </button>
            </div>

        </div>

    </form>


</div>
